var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{directives:[{name:"title",rawName:"v-title"}],staticClass:"header_home user_reg",attrs:{"data-title":"课时教案"}},[_c('div',{staticClass:"plan-class"},[_c('div',{staticClass:"main-class",domProps:{"innerHTML":_vm._s(_vm.planText)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }